import tickets from 'api/tickets'
import * as types from '../mutation-types'
let token = window.localStorage.getItem('accessToken')

export const saveTicketsType = ({ commit, rootState }, data) => {
  commit(types.TICKET_TYPE, data)
}
export const saveTicketsGroup = ({ commit, rootState }, data) => {
  commit(types.TICKET_GROUP, data)
}
export const saveTicketsMembers = ({ commit, rootState }, data) => {
  commit(types.TICKET_MEMBERS, data)
}
export const fetchTicketTypes = ({commit, rootStats}, data) => {
  return tickets.ticketTypes().then((data) => {
    commit(types.TICKET_TYPES, data)
    return Promise.resolve(data)
  })
}
export const queryMembers = ({ commit, rootState }, account) => {
  return tickets.query(token, account).then((data) => {
    return Promise.resolve(data)
  }, (err) => {
    return Promise.reject(err)
  })
}
export const submitRegister = ({ commit, rootState }, params) => {
  console.log('params', params)
  if (params.ticketType === 'single') {
    return tickets.rigester(token, params).then((data) => {
      console.log('rigister[single] result: ', data)
      return Promise.resolve(data)
    }, (err) => {
      return Promise.reject(err)
    })
  } else if (params.ticketType === 'group') {
    return tickets.rigesterGroup(token, params).then((data) => {
      console.log('rigister[group] result: ', data)
      return Promise.resolve(data)
    }, (err) => {
      return Promise.reject(err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/tickets/actions.js